import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 999;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

const getWidth = ({ width }: IContainer) => {
  if (typeof width === 'string') return width;
  return `${width || 379}px`;
};
interface IContainer {
  width?: number | string;
}
export const Container = styled.div<IContainer>`
  /* Layout Properties */

  width: ${getWidth};
  // display: flex;
  align-self: center;
  //align-items: center;
  justify-self: center;
  //justify-content: space-between;
  z-index: 10;
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 18px 24px 24px 24px;
  /* UI Properties */
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  grid-template-columns: minmax(min-content, 500px) 1fr;
  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
`;
export const Cancel = styled.button`
  font-size: 14px;
  background: none;
  font-weight: 500;

  color: #474d66;

  background-color: #fff;
  /* borders/default-border */
  border: 1px solid #d8dae5;
  box-sizing: border-box;
  border-radius: 8px;
  white-space: nowrap;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  height: 42px;
  padding: 10px 16px;
  margin-right: 8px;
`;

interface IDelete {
  backgroundColor?: string;
  blocked?: boolean;
}

export const Delete = styled.button<IDelete>`
  font-size: 14px;
  white-space: nowrap;
  font-weight: 500;
  cursor: pointer;
  border: 1px solid ${beam.border.back};
  height: 42px;
  background-color: ${({ backgroundColor }) => backgroundColor || '#d14343'};
  /* beam-colors/beam-red */
  color: #ffffff;
  border-radius: 8px;
  padding: 0 16px;
  /* Inside Auto Layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  opacity: ${({ blocked }) => (blocked ? 0.7 : 1)};
`;
export const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #161a30;
`;
export const Text = styled.span`
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 28px;
  color: #474d66;

  &[data-inputcheck] {
    margin-bottom: unset;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #474d66;

      &.bold {
        font-weight: 600;
      }
    }
  }
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  margin-bottom: 28px;
`;

export const CloseButton = styled.button`
  display: flex;
  background-color: transparent;
  border: 0;
  padding-top: 6px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const InputTextCheckWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 28px;
`;

export const InputTextCheck = styled.p`
  font-size: 13px;
  margin: unset;
  font-weight: 400;
  color: #474d66;
`;

export const InputTextCheckSpan = styled.q`
  font-size: 14px;
  margin: unset;
  color: #474d66;
`;

export const InputCheckFieldWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background-color: transparent;
  border: 1px solid #d8dae5;
  padding: 8px 10px;
  border-radius: 6px;

  span {
    display: inline-flex;
    cursor: pointer;
  }
`;

export const InputCheckField = styled.input`
  all: unset;
  width: 100%;
  font-size: 14px;
  color: #474d66;
`;

export const DeleteButton = styled.button`
  all: unset;
  font-size: 14px;
  white-space: nowrap;
  font-weight: 500;
  border: 1px solid ${beam.border.back};
  height: 42px;
  background-color: #d14343;
  color: #ffffff;
  border-radius: 8px;
  padding: 0px 16px;
  cursor: pointer;
  text-align: center;

  :disabled {
    cursor: not-allowed;
    color: #c1c4d6;
    background-color: #edeff4;
  }
`;
